export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5287.41fa8929.jpg";